import * as shared from '@iws/theme-schema/campaign-blocks'

import { FieldSchema } from '@/lib/builder/schemas'
import { OfferModel } from '@/types'

// The catalog lives in @iws/theme-schema (shared with the storefront). Campaign blocks only use field
// types the admin's FieldRenderer supports, so they are typed with its FieldSchema here.
export type CampaignBlockVariant = shared.CampaignBlockVariant
export interface CampaignBlockDef extends Omit<shared.CampaignBlockDef, 'fields'> {
  fields: FieldSchema[]
}

export const BLOCK_STYLE_SCHEMA = shared.BLOCK_STYLE_SCHEMA as FieldSchema[]
export const BLOCK_CATALOG = shared.BLOCK_CATALOG as unknown as Record<OfferModel.OfferType, CampaignBlockDef[]>

export const getBlockDef = (offerType: OfferModel.OfferType, blockType: string): CampaignBlockDef | undefined =>
  shared.getBlockDef(offerType, blockType) as CampaignBlockDef | undefined

export const buildBlockDefaults = shared.buildBlockDefaults
